import { render, staticRenderFns } from "./ManageArchivedData.vue?vue&type=template&id=2c0b6e6a&scoped=true&"
import script from "./ManageArchivedData.vue?vue&type=script&lang=ts&"
export * from "./ManageArchivedData.vue?vue&type=script&lang=ts&"
import style0 from "./ManageArchivedData.vue?vue&type=style&index=0&id=2c0b6e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b6e6a",
  null
  
)

export default component.exports